import { createContext, useContext } from 'react'
import { useParams, Outlet } from 'react-router-dom'

interface InterviewContextValue {
  apiPath: string
  chatUrl: string
  doneUrl: string
  welcomeUrl: string
  canSuggestAnswer?: boolean
}

const InterviewContext = createContext<InterviewContextValue | null>(null)

export function useInterviewContext() {
  const ctx = useContext(InterviewContext)
  if (!ctx) throw new Error('useInterviewContext must be used within an interview layout route')
  return ctx
}

export function TokenInterviewLayout() {
  const { token } = useParams<{ token: string }>()
  return (
    <InterviewContext.Provider value={{
      apiPath: `/api/v1/interview/${token}`,
      chatUrl: `/i/${token}/chat`,
      doneUrl: `/i/${token}/done`,
      welcomeUrl: `/i/${token}`,
    }}>
      <Outlet />
    </InterviewContext.Provider>
  )
}

export function AssessmentInterviewLayout() {
  const { assessmentId } = useParams<{ assessmentId: string }>()
  return (
    <InterviewContext.Provider value={{
      apiPath: `/api/v1/interview/assessment/${assessmentId}`,
      chatUrl: `/assessment/${assessmentId}/interview/chat`,
      doneUrl: `/assessment/${assessmentId}/interview/done`,
      welcomeUrl: `/assessment/${assessmentId}/interview`,
      canSuggestAnswer: true,
    }}>
      <Outlet />
    </InterviewContext.Provider>
  )
}
